import inegiPxWeb from '../api/inegi-pxweb';
import { setStubHeadingFromColumn } from './pivot';

export const fetchMetaData = () => async (dispatch, getState) => {
    const { lang, file } = getState().selection;
    const response = await inegiPxWeb.get('/tabulado', {
        params: { lang, file }
    });
    dispatch({ type: 'FETCH_METADATA', payload: response.data })
}

export const fetchInfo = () => async (dispatch, getState) => {
    const mmm = getState().selection;
    const response = await inegiPxWeb.post('/info', mmm);
    dispatch({ type: 'FETCH_INFO', payload: response.data })
}

export const fetchData = () => async (dispatch, getState) => {
    const { stub, heading } = getState().column;
    dispatch(setStubHeadingFromColumn(stub, heading));
    const mmm = getState().selection;
    const response = await inegiPxWeb.post('/datatable', mmm);
    dispatch({ type: 'FETCH_DATA', payload: response.data })
}

export const getPXQ = () => async (dispatch, getState) => {
    const mmm = getState().selection;
    const response = await inegiPxWeb.post('/tabquery', mmm);
    dispatch({ type: 'GET_PXQ', payload: response.data.pxq })
}

export const fetchPXQ = (pxq) => async (dispatch) => {
    const response = await inegiPxWeb.get('/tabquery', {
        params: { pxq }
    });
    dispatch({ type: 'FETCH_PXQ', payload: response.data })
}